"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelAudience = void 0;
var ChannelAudience;
(function (ChannelAudience) {
    ChannelAudience["ndsDigital"] = "NDS_DIGITAL";
    ChannelAudience["nvs"] = "NVS";
})(ChannelAudience || (exports.ChannelAudience = ChannelAudience = {}));
